import { handleOnChangeDataSecondCoOwnerRenewal } from './helpers';
import {
  getQuotation,
  getSecondCoownerData,
} from 'app/services/businessFunctionHelpers';
import { checkHasDataChangedForRenewal } from 'app/services/businessFunctions/helpers/checkHasDataChangedForRenewal';

const onSecondCoownerLastNameChange = {
  onSecondCoownerLastNameChange(initialRun?: boolean) {
    const { lastName } = getSecondCoownerData();
    const { coOwners } = getQuotation();

    const previousLastName = coOwners?.[1]?.lastName || '';

    if (checkHasDataChangedForRenewal(lastName, previousLastName)) {
      handleOnChangeDataSecondCoOwnerRenewal(initialRun);
    }
  },
};

export default onSecondCoownerLastNameChange;
